import LoadingOverlay from "react-loading-overlay";
import { styled } from "styled-components";

export const StyledLoader = styled(LoadingOverlay)`
    height: 100vh;
`;